module.exports = __webpack_public_path__ + "img/free_multiplier_10.68818fcf.png";